import React, { useEffect, useState } from "react";
import Image from 'next/image'

// import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
// import "swiper/css";
// import "swiper/css/free-mode"
// import "swiper/css/navigation"
// import "swiper/css/thumbs"

// import Swiper core and required modules
// import SwiperCore, {
//     FreeMode, Navigation, Thumbs
// } from 'swiper';

// SwiperCore.use([FreeMode, Navigation, Thumbs]);



function Productimage({ item }) {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [default_img, setDefaultImage] = useState(0);
    const [default_img_found, setDefaultImageFound] = useState(false);

    // set png/jpg as default cause there as pdfs files are also attached in media
    useEffect(() => {
        let index = 0;
        item.media.forEach(element => {
            if (element.collection_name == "default") {
                if (!default_img_found) {
                    setDefaultImageFound(true)
                    setDefaultImage(index)
                }
            }
            index++;
        });
    }, [item])

     // set png/jpg as default cause there as pdfs files are also attached in media
     const getfirstimage = (item) => {
        var index = 0;
        var isfound = false;
        var imgindex = 0;
        item.media.forEach(element => {
            if (element.collection_name == "default") {
                if (!isfound) {
                    imgindex = index
                    isfound = true
                }
            }
            index++;
        });
        return imgindex
    }


    return (
        <div className="w-full">
            <div className="w-full">

                {(item && item.media && item.media[getfirstimage(item)] && item.media[getfirstimage(item)].original_url) ? (
                    <>

                        <Image
                            src={item.media[getfirstimage(item)].original_url}
                            alt={item.name}
                            width={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                            height={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                            className="bg-white mb-4 w-full object-contain"
                            placeholder="blur"

                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                        />

                        {/* <Swiper
                            style={{ '--swiper-navigation-color': '#002e3e', '--swiper-pagination-color': '#002e3e' }}
                            loop={true}
                            spaceBetween={10}
                            navigation={true}
                            centeredSlides={true}
                            className="small-swiper bg-white mb-2 rounded"
                        >
                            {item.media.map((image) => (
                                <SwiperSlide key={image.id}>
                                    <Image
                                        src={image.original_url}
                                        alt={item.name}
                                        width={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                                        height={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                                        className="bg-white mb-4 w-full object-contain"
                                        placeholder="blur"

                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                    />
                                </SwiperSlide>
                            ))}
                            {item.variations.map((variation) => (
                                variation.media.map((image) => (
                                    <SwiperSlide key={image.id}>
                                        <Image
                                            src={image.original_url}
                                            alt={variation.name}
                                            width={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                                            height={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                                            className="bg-white mb-4 w-full object-contain"
                                            placeholder="blur"

                                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                                        />
                                    </SwiperSlide>
                                ))
                            ))}
                        </Swiper> */}
                    </>
                ) : (
                    <>
                        <Image
                            src={process.env.NEXT_PUBLIC_COMING_SOON_IMAGE}
                            alt={item.name}
                            height={process.env.NEXT_PUBLIC_SMALL_IMAGE_HEIGHT}
                            width={process.env.NEXT_PUBLIC_SMALL_IMAGE_WIDTH}
                            className="bg-white mb-4 w-full object-contain"
                            placeholder="blur"

                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                        />
                    </>
                )}
            </div>
        </div>

    );
}

export default Productimage;